/**
 * Admin home component fetch all post from database and displays also filter and delete posts
 */
import React from 'react';
import * as postsActions from '../../../store/admin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Posts, Email, EmailLogs, WebLogs, ReadPosts, LVGoalsPDF, Places, SubscribedUsers, LVGoalsUpload } from '../../admin';
import * as _ from 'lodash';
import { Container } from 'react-bootstrap';
import { BackStrip, Header } from '../../../common/layout';
import { config } from '../../../config/config';
import { deviceDetect } from 'react-device-detect';
import { utilService } from '../../../common/utils';

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.redirect = this.redirect.bind(this);
    this.state = {
      activeTab: "posts",
      isLoading: false,
      isReseting: false,
      isFitering: false,
      isDeleating: false,
      errors: {},
    };
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    // google analytic page view
    utilService.pageView();
    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "admin",
      title: "Admin Home",
      browserName: browserName,
      osName: osName,
      pageType: "Admin Home Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });
  }
  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs.
   * @param {*} prevProps : Getting previous props
   * @param {*} prevState : Getting previous state
   */
  componentDidUpdate(prevProps, prevState) { }
  /**
   * Navigate to other page
   * @param {} url
   */
  redirect(url) {
    this.props.history.push(url);
  }

  onClickTab(componentName, e) {
    console.log(componentName);
    // console.log(e);
    this.setState({
      activeTab: componentName,
    });
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    return (
      <div>
        <BackStrip nav="/" isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header cname="admin-home" text="Admin Home" />
            <main className="admin-home">
              <Container fluid className="container-default-space">
                <div className="row brd-btm">
                  <ul
                    className="nav nav-pills mb-3"
                    id="admin-tab"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="dashboard-tab"
                        data-toggle="pill"
                        href="#dashboard"
                        role="tab"
                        aria-controls="dashboard"
                        aria-selected="true"
                      >
                        Dashboard
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="places-tab"
                        data-toggle="pill"
                        href="#places"
                        role="tab"
                        aria-controls="places"
                        onClick={this.onClickTab.bind(this, "places")}
                        aria-selected="false"
                      >
                        Places
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="posts-tab"
                        data-toggle="pill"
                        href="#posts"
                        role="tab"
                        onClick={this.onClickTab.bind(this, "posts")}
                        aria-controls="posts"
                        aria-selected="false"
                      >
                        Posts
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="email-tab"
                        data-toggle="pill"
                        href="#email"
                        role="tab"
                        aria-controls="email"
                        onClick={this.onClickTab.bind(this, "email")}
                        aria-selected="false"
                      >
                        Email
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="email-logs-tab"
                        data-toggle="pill"
                        href="#email-logs"
                        onClick={this.onClickTab.bind(this, "emailLogs")}
                        role="tab"
                        aria-controls="email-logs"
                        aria-selected="false"
                      >
                        Email Logs
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="web-logs-tab"
                        data-toggle="pill"
                        href="#web-logs"
                        role="tab"
                        aria-controls="web-logs"
                        onClick={this.onClickTab.bind(this, "webLogs")}
                        aria-selected="false"
                      >
                        Web Logs
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="read-posts-tab"
                        data-toggle="pill"
                        href="#read-posts"
                        role="tab"
                        aria-controls="read-posts"
                        onClick={this.onClickTab.bind(this, "readPosts")}
                        aria-selected="false"
                      >
                        Read Posts
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="subscribed-tab"
                        data-toggle="pill"
                        href="#subscribed"
                        role="tab"
                        aria-controls="subscribed"
                        onClick={this.onClickTab.bind(this, 'subscribedUsers')}
                        aria-selected="false"
                      >
                        Subscribed
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="learningGoalPDF-tab"
                        data-toggle="pill"
                        href="#learningGoalPDF"
                        role="tab"
                        aria-controls="learningGoalPDF"
                        onClick={this.onClickTab.bind(this, 'learningGoalPDF')}
                        aria-selected="false"
                      >
                        LV Goals PDFs
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="learningGoalUpload-tab"
                        data-toggle="pill"
                        href="#learningGoalUpload"
                        role="tab"
                        aria-controls="learningGoalUpload"
                        onClick={this.onClickTab.bind(this, 'learningGoalUpload')}
                        aria-selected="false"
                      >
                        LV Goals Upload
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="admin-tabContent">
                  <div
                    className="tab-pane fade"
                    id="dashboard"
                    role="tabpanel"
                    aria-labelledby="dashboard-tab"
                  />
                  <div
                    className="tab-pane fade"
                    id="places"
                    role="tabpanel"
                    aria-labelledby="places-tab"
                  >
                    {this.state.activeTab === "places" && (
                      <Places onEditPlaceButton={this.redirect} />
                    )}
                  </div>
                  <div
                    className="tab-pane fade show active"
                    id="posts"
                    role="tabpanel"
                    aria-labelledby="posts-tab"
                  >
                    {this.state.activeTab === "posts" && (
                      <Posts onEditPostButton={this.redirect} />
                    )}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="email"
                    role="tabpanel"
                    aria-labelledby="email-tab"
                  >
                    {this.state.activeTab === "email" && <Email />}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="email-logs"
                    role="tabpanel"
                    aria-labelledby="email-logs-tab"
                  >
                    {this.state.activeTab === "emailLogs" && <EmailLogs />}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="web-logs"
                    role="tabpanel"
                    aria-labelledby="web-logs-tab"
                  >
                    {this.state.activeTab === 'webLogs' && <WebLogs />}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="read-posts"
                    role="tabpanel"
                    aria-labelledby="read-posts-tab"
                  >
                    {this.state.activeTab === 'readPosts' && <ReadPosts />}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="subscribed"
                    role="tabpanel"
                    aria-labelledby="subscribed-tab"
                  >
                    {this.state.activeTab === 'subscribedUsers' && <SubscribedUsers />}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="learningGoalPDF"
                    role="tabpanel"
                    aria-labelledby="learningGoalPDF-tab"
                  >
                    {this.state.activeTab === 'learningGoalPDF' && <LVGoalsPDF />}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="learningGoalUpload"
                    role="tabpanel"
                    aria-labelledby="learningGoalUpload-tab"
                  >
                    {this.state.activeTab === 'learningGoalUpload' && <LVGoalsUpload />}
                  </div>
                </div>
                {/* <div className="row justify-content-end brd-btm">
                  <ul className="nav nav-pills d-flex justify-content-center" role="tablist">
                    <li className="nav-item">
                      <a className="nav-link active" data-toggle="pill" href="#current">Admin Home</a>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link" to="/admin/email-logs">Email Logs</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link" to="/admin/web-logs">Web Logs</NavLink>
                    </li>
                  </ul>
                </div> */}
              </Container>
            </main>
          </div>
        </div>
        <div className="overlay"></div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
  return {
    postActionLoading: state.posts.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(postsActions, dispatch)
)(Admin);
